import { render, staticRenderFns } from "./customer_list.vue?vue&type=template&id=c17594c4&scoped=true"
import script from "./customer_list.vue?vue&type=script&lang=js"
export * from "./customer_list.vue?vue&type=script&lang=js"
import style0 from "./customer_list.vue?vue&type=style&index=0&id=c17594c4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17594c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c17594c4')) {
      api.createRecord('c17594c4', component.options)
    } else {
      api.reload('c17594c4', component.options)
    }
    module.hot.accept("./customer_list.vue?vue&type=template&id=c17594c4&scoped=true", function () {
      api.rerender('c17594c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/product_price_maintain/components/customer_list.vue"
export default component.exports